import { createSelector } from 'reselect';

import { getProgramsCategory } from './programsCategory.selectors';

export const getChannelPrograms = createSelector(
  getProgramsCategory,
  ({ channelPrograms }) => channelPrograms,
);
